export const getTimelineScrollContainer = () => {
  var _document$querySelect;
  return ((_document$querySelect = document.querySelector('[data-card-type="RECORD_TIMELINE"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.closest('[data-scroll-container] > div')) || null;
};